export default __webpack_public_path__ + "static/media/main-category-kitchen-pop-ups.6b5f37e8.jpg";